import React from "react";

export const Flags = {
    tr: (
        <svg
            width="20"
            height="15"
            viewBox="0 0 640 480"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fill="#e30a17" d="M0 0h640v480H0z"/>
            <circle cx="270" cy="240" r="90" fill="#fff"/>
            <circle cx="295" cy="240" r="67.5" fill="#e30a17"/>
            <polygon
                fill="#fff"
                points="352,240 410,270 388,210 388,270 410,210"
            />
        </svg>
    ),
    gb: (
        <svg
            width="20"
            height="15"
            viewBox="0 0 60 30"
            xmlns="http://www.w3.org/2000/svg"
        >
            <clipPath id="t">
                <path d="M0,0 v30 h60 v-30 z"/>
            </clipPath>
            <clipPath id="s">
                <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/>
            </clipPath>
            <g clipPath="url(#t)">
                <path d="M0,0 v30 h60 v-30 z" fill="#012169"/>
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6"/>
                <path
                    d="M0,0 L60,30 M60,0 L0,30"
                    clipPath="url(#s)"
                    stroke="#C8102E"
                    strokeWidth="4"
                />
                <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10"/>
                <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
            </g>
        </svg>
    ),
};
